<!-- Global Hero Section -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg'); background-position: center 30%;">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <h1 class="hero-title-global">Become a Member</h1>
    <p class="lead"
      style="color: rgba(255,255,255,0.9); border: none; background: none; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">
      Join our community of supporters and help keep Bayou Lacombe’s heritage alive.
    </p>
  </div>
</header>

<main class="container signup-container">
  <div class="signup-grid">
    <!-- Info Side Card -->
    <div class="info-side-card">
      <span class="badge">Your Membership Impact</span>
      <h2>Supporting History</h2>
      <p>
        As a 501(c)(3) nonprofit, the Bayou Lacombe Museum depends on member dues to fund artifact preservation, educational programming for schools, and the maintenance of our historic 1912 wooden schoolhouse.
      </p>

      <div class="perks-summary">
        <h4>Member Privileges:</h4>
        <div class="perk-row">
          <mat-icon class="perk-check">verified</mat-icon>
          <span>Free admission for a full year</span>
        </div>
        <div class="perk-row">
          <mat-icon class="perk-check">verified</mat-icon>
          <span>Invitations to exhibit openings & lectures</span>
        </div>
        <div class="perk-row">
          <mat-icon class="perk-check">verified</mat-icon>
          <span>Official Bayou Lacombe Museum ceramic mug</span>
        </div>
        <div class="perk-row">
          <mat-icon class="perk-check">verified</mat-icon>
          <span>20% discount on museum gift store items</span>
        </div>
      </div>

      <div class="back-link-box">
        <a routerLink="/memberships" class="back-link">
          <mat-icon>arrow_back</mat-icon>
          View all tier details & pricing
        </a>
      </div>
    </div>

    <!-- Application Form Card -->
    <div class="form-side-card">
      <div [hidden]="success">
        <h3>Membership Application</h3>
        <p class="form-intro">Select your tier and enter your contact details to begin.</p>

        <form [formGroup]="memberForm" (ngSubmit)="onSubmit()" class="styled-member-form">
          <!-- Tier Selection -->
          <div class="tier-select-section">
            <label class="section-label">Select Membership Tier:</label>
            <mat-radio-group formControlName="membership" class="tier-radio-group">
              <mat-radio-button value="family" color="primary">
                <strong>Family Membership</strong> — $50/yr
              </mat-radio-button>
              <mat-radio-button value="individual" color="primary">
                <strong>Individual</strong> — $30/yr
              </mat-radio-button>
              <mat-radio-button value="student-vet-senior" color="primary">
                <strong>Student / Veteran / Senior</strong> — $20/yr
              </mat-radio-button>
              <mat-radio-button value="patron" color="primary">
                <strong>Patron Supporter</strong> — $500/yr
              </mat-radio-button>
              <mat-radio-button value="benefactor" color="primary">
                <strong>Benefactor Circle</strong> — $2,000/yr
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <!-- Contact Fields -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Full Name</mat-label>
            <input matInput placeholder="e.g. Eleanor Davis" formControlName="name" autocomplete="name" required>
            <mat-icon matPrefix>person</mat-icon>
            <mat-error *ngIf="name.errors && (name.dirty || name.touched)">
              Name is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email Address</mat-label>
            <input matInput placeholder="eleanor@example.com" formControlName="email" autocomplete="email" required>
            <mat-icon matPrefix>email</mat-icon>
            <mat-error *ngIf="email.errors && (email.dirty || email.touched)">
              Valid email is required
            </mat-error>
          </mat-form-field>

          <button mat-flat-button color="primary" class="submit-btn" [disabled]="memberForm.invalid || loading" type="submit">
            <mat-icon>card_membership</mat-icon>
            {{ loading ? 'Processing...' : 'Submit Membership Application' }}
          </button>
        </form>
      </div>

      <div class="success-message" *ngIf="success">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h3>Welcome to the Museum Family!</h3>
        <p>Your membership application for <strong>{{ submittedData.tierName }}</strong> has been recorded.</p>
        
        <div class="email-action-box">
          <p class="email-action-desc">
            To notify the museum board immediately or inquire about paying dues via check/card, click below to open your email client with your prefilled details:
          </p>
          <a [href]="mailtoLink" class="email-confirm-btn">
            <mat-icon>email</mat-icon>
            <span>Open Email to Confirm With Museum</span>
          </a>
        </div>

        <div style="margin-top: 1.5rem;">
          <button mat-stroked-button color="primary" routerLink="/">Return to Homepage</button>
        </div>
      </div>
    </div>
  </div>
</main>

